import type React from 'react';

import { Alert } from '@change/ds-core-ui';

import { Translate, TranslatePlural, useI18n } from '@change-corgi/core-react/i18n';

import { useFreePromotionFulfillment } from './hooks/useFreePromotionFulfillment';

type Props = {
	onDismiss?: () => void;
};

export const FreePromotionFulfillment: React.FC<Props> = ({ onDismiss }) => {
	const { data, actions } = useFreePromotionFulfillment({ onDismiss });
	const { translate } = useI18n();

	return (
		<Alert
			className="h-full w-full [&>div>div]:flex-row"
			variant="info"
			{...(onDismiss && {
				onDismissClick: actions.handleDismiss,
				dismissButtonAriaLabel: translate(
					'corgi.petition.starter_dashboard.notifications.free_promo_fulfillment.dismiss_button_aria_label',
				),
			})}
			heading={
				<TranslatePlural
					value="corgi.petition.starter_dashboard.notifications.free_promo_fulfillment.title"
					replacements={{ numSignatures: data.signaturesLocalized }}
					count={data.signatures}
				/>
			}
			data-qa="free-promotion-fulfillment-section-message"
		>
			<Translate value="corgi.petition.starter_dashboard.notifications.free_promo_fulfillment.body" />
		</Alert>
	);
};
